export default __webpack_public_path__ + "static/media/agreement.eb69669b.png";